import { render, staticRenderFns } from "./StepConfirmarDatos.vue?vue&type=template&id=32f5bce7&"
import script from "./StepConfirmarDatos.vue?vue&type=script&lang=js&"
export * from "./StepConfirmarDatos.vue?vue&type=script&lang=js&"
import style0 from "./StepConfirmarDatos.vue?vue&type=style&index=0&id=32f5bce7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports